<div class="mct-flex mct-col" >
  <label>{{ 'profiles.edit.profile-type.title' | translate | titlecase }}</label>
  <p-select
    [(ngModel)]="profile.ProfileTypeId"
    [placeholder]="'common.none' | translate | titlecase"
    [options]="profileTypeItems"
    showClear
  ></p-select>
</div>

<div [ngSwitch]="profile?.ProfileTypeId">
  <div *ngSwitchCase="naaProfileTypeEnum.ManagementCompany">
    <wl-profile-type-management-company-edit [profileId]="profile?.ProfileId"></wl-profile-type-management-company-edit>
  </div>
  <div *ngSwitchCase="naaProfileTypeEnum.Owner">
    <wl-profile-type-owner-edit [profileId]="profile?.ProfileId"></wl-profile-type-owner-edit>
  </div>
  <div *ngSwitchCase="naaProfileTypeEnum.Property">
    <wl-profile-type-property-edit [profileId]="profile?.ProfileId"></wl-profile-type-property-edit>
  </div>
</div>
